export default {"src":"/_next/static/media/office365.ce42f62e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};